import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowUpRightFromSquare,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from '~/components/ui/Link';
import Panel from '~/components/ui/Panel';
import { Address } from '~/types/common/Address';

type CompanyContactPanelProps = {
  companyName: string;
  address?: Address;
  phoneNumber?: string;
  emailAddress?: string;
  websiteAddress?: string;
};

const CompanyContactPanel: React.FC<CompanyContactPanelProps> = ({
  companyName,
  phoneNumber,
  emailAddress,
  websiteAddress,
  address,
}) => {
  if (!address && !phoneNumber && !emailAddress && !websiteAddress) {
    return null;
  }
  
  return (
    <Panel>
      <h3 className="panel-title--primary">
        Informatie, advies &amp; afsluiten
      </h3>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-12">
        <div>
          <h4 className="panel-title--secondary">Contactgegevens</h4>
          <div>
            {address && (
              <section className="gap-15 flex flex-row justify-start py-2">
                <div className="w-[100px] font-bold text-blue-800">Adres</div>
                <div>
                  {address.street} {address.houseNumber} {address.addition}
                  <br />
                  {address.zipcode.toUpperCase()} {address.locality}
                </div>
              </section>
            )}
            {phoneNumber && (
              <section className="gap-15 flex flex-row justify-start py-2">
                <div className="w-[100px] font-bold text-blue-800">
                  Telefoon
                </div>
                <div>{phoneNumber}</div>
              </section>
            )}
            {emailAddress && (
              <section className="gap-15 flex flex-row justify-start py-2">
                <div className="w-[100px] font-bold text-blue-800">E-mail</div>
                <div>
                  <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
                </div>
              </section>
            )}
          </div>
        </div>
        {websiteAddress && (
          <div>
            <h4 className="panel-title--secondary">Contact opnemen</h4>
            <div>
              <Link
                variant="default"
                href={websiteAddress}
                target="_blank"
                className="mt-6"
              >
                <FontAwesomeIcon icon={faArrowUpRightFromSquare as IconProp} />
                Bezoek de website van {companyName}
                <FontAwesomeIcon icon={faChevronRight as IconProp} />
              </Link>
            </div>
          </div>
        )}
      </div>
    </Panel>
  );
};

export default CompanyContactPanel;
